export default __webpack_public_path__ + "static/media/canvas_background.1677fb6d.svg";